import React, { Component } from 'react'
import { Switch } from 'antd'

class MapLayerSwitcher extends Component {

    constructor(props) {
        super(props)
        this.toggleVisible = this.toggleVisible.bind(this)
    }

    toggleVisible(l, visible) {
        this.props.map.getLayers().forEach((item) => {
            if (l.get('baseLayer') && item.get('baseLayer')) {
                item === l ? item.setVisible(visible) : item.setVisible(false)
            } else {
                item.setVisible(visible)
            }
        })
        this.forceUpdate()
    }

    render() {
        var layers = []
        this.props.map.getLayers().forEach((l) => {
            if (l.get('name') !== 'Ocorrências') layers.push(l)
        })
        return (
            <div id="LayerSwitcher">
                <ul>
                    { layers.map((l) => {
                        return (
                            <li key={l.get('id')}>
                                <Switch size="small" id={l.get('id')} type="checkbox"
                                    checked={l.getVisible()}
                                    onChange={(checked) => { this.toggleVisible(l, checked) }}
                                />{' '}
                                <label htmlFor={l.get('id')}>{l.get('name')}</label>
                            </li>
                        )
                    }) }
                </ul>
            </div>
        )
    }
}

export default MapLayerSwitcher



// WEBPACK FOOTER //
// ./src/components/MapLayerSwitcher.js